// extracted by css-extract-rspack-plugin
export default {"tabList":"_16724c72","fullWidth":"_71029632","center":"_de4d0f8c","container":"_ca4839e0","left":"_b7457a9c","overflowContainer":"_5375b73c"};